import { Component, Input, inject } from '@angular/core';
import { NgbCarouselConfig, NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { CompletedFormFileModel } from 'src/app/models/completedForm-file.model';
import { FileServerService } from 'src/app/services/file-server.service';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { HideIfNoPermissionDirective } from '../../directives/HideIfNoPermissionDirective';

@Component({
  selector: 'app-images-carousel',
  templateUrl: './images-carousel.component.html',
  styleUrls: ['./images-carousel.component.scss'],
  providers: [NgbCarouselConfig],
  standalone: true,
  imports: [NgbCarousel, NgbSlide, HideIfNoPermissionDirective]
})
export class ImagesCarouselComponent {
  private readonly FileServerSrv = inject(FileServerService);
  private readonly toastr = inject(ToastService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);
  config = inject(NgbCarouselConfig);

  @Input() files: CompletedFormFileModel[] = [];

  constructor() {
    this.config.interval = 0;
    this.config.keyboard = true;
    this.config.showNavigationIndicators = true;
    this.config.showNavigationArrows = true;
  }

  openImage(url: any) {
    window.open(url, '_blank');
  }

  deleteFile(event: Event, file: CompletedFormFileModel, index: number) {
    event.stopPropagation(); // Evita que se abra la imagen al querer borrarla

    this.swalFire
      .SwalFireQuestion(
        'Eliminar',
        '¿Desea eliminar este archivo permanentemente?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.FileServerSrv.delete(file.fileId).subscribe({
            next: () => {
              this.files.splice(index, 1);
              this.toastr.success('Eliminado', 'Archivo eliminado correctamente.');
            },
            error: () => this.toastr.error('Error', 'No se pudo eliminar el archivo.')
          });
        }
      });
  }
}